import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateWF',
  standalone: true,
  pure: false,
})
export class TranslateWithFallbackPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(key: string, fallback: string): string {
    const translation = this.translate.instant(key);
    return translation === key ? fallback : translation;
  }
}
